import ApplicationAdapter from '../application';

export default class Base extends ApplicationAdapter {
  namespace = 'enrolments/v4';

  pathForType() {
    return super
      .pathForType(...arguments)
      .replace('enrolments/', '')
      .toLowerCase();
  }
}
